<template>
  <div
    class="newsContent"
    :class="{ 'animate__animated animate__fadeInDown animate__delay-1s': !loading }"
    :aria-busy="loading"
  >
    <div
      v-if="loading"
      class="detail-loading"
      role="status"
      :aria-label="$i18n.locale === 'en-US' ? 'Loading news' : '正在加载新闻'"
    >
      <span class="spinner-border text-primary" aria-hidden="true"></span>
    </div>
    <template v-else>
      <h1 class="title">{{this.newContent.title}}</h1>
      <!-- <div class="sources">发布时间：{{this.newContent.publishDate}} 来源： 智会云科技</div> -->
      <!-- 富文本内容渲染 -->
      <div class="editor ql-snow ql-editor" v-html="newContent.content"></div>
    </template>
  </div>
</template>

<script>
import { getContent } from '@/api/editNews'
export default {
  data () {
    return {
      newContent: [],
      loading: true
    }
  },
  created () {
    this.getContent(this.$route.params.slug)
    document.documentElement.scrollTop = 0
  },
  methods: {
    // 获取资讯详细内容
    async getContent (id) {
      this.loading = true
      try {
        const res = await getContent(id)
        if (res.code === 0) {
          this.newContent = res.data.news
        } else {
          this.$message.error(res.msg)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.newsContent{
  width: 100%;
  max-width: 1200px;
  margin: 30px auto 80px;
  padding: 0 24px;
  box-sizing: border-box;
  .title{
    font-size: clamp(18px, 2.2vw, 24px);
    text-align: center;
    border-bottom: 1px dotted #ccc;
    padding: 8px 0px;
    margin: 10px 0px;
    letter-spacing: 3px;
    word-break: break-word;
    font-weight: inherit;
  }
  .sources{
    text-align: center;
    letter-spacing: 3px;
  }
  .editor{
    line-height: 2;
    padding: 0 18px;
    font-size: clamp(14px, 1.7vw, 16px);
    margin-top: 20px;
    box-sizing: border-box;
    overflow: hidden;
    word-break: break-word;
  }
  .detail-loading{
    min-height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
}

@media (max-width: 1199.98px) {
  .newsContent {
    padding: 0 15px;
    margin: 24px auto 56px;
  }
}

@media (max-width: 767.98px) {
  .newsContent {
    padding: 0 12px;
    margin: 16px auto 36px;

    .title {
      letter-spacing: 1px;
      margin: 6px 0;
      padding: 6px 0;
    }

    .editor {
      padding: 0;
      margin-top: 12px;
      line-height: 1.8;
    }

    .detail-loading {
      min-height: 180px;
    }
  }
}
</style>
